import { Link } from 'react-router-dom'
import Logo from '@/components/common/Logo'

export default function DesktopFooter() {
  return (
    <footer className="bg-slate-900 mt-auto">
      {/* 모바일에서도 노출(신뢰 페이지 접근성). BottomNav(고정) 가림 방지 하단 여백. */}
      <div className="max-w-7xl mx-auto px-6 py-10 pb-24 lg:py-14 lg:pb-14">
        <div className="grid grid-cols-2 gap-8 lg:grid-cols-4 lg:gap-10">
          {/* Brand */}
          <div className="col-span-2 lg:col-span-1">
            <div className="mb-4">
              <Logo variant="light" size="md" />
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">
              부모님 요양시설, 함께 찾아드려요.
              <br />
              전국 3만여 개 요양시설 정보 비교,
              <br />
              AI 맞춤 추천, 비용 계산, 입소 상담까지.
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-sm font-bold text-white mb-4">서비스</h3>
            <div className="flex flex-col gap-2.5">
              <Link to="/facilities" className="text-sm text-slate-400 hover:text-white transition-colors">시설 검색</Link>
              <Link to="/cost-simulator" className="text-sm text-slate-400 hover:text-white transition-colors">요양비용 계산기</Link>
              <Link to="/recommend" className="text-sm text-slate-400 hover:text-white transition-colors">AI 맞춤 추천</Link>
              <Link to="/guide/self-assessment" className="text-sm text-slate-400 hover:text-white transition-colors">요양등급 자가진단</Link>
              <Link to="/mypage/care-log" className="text-sm text-slate-400 hover:text-white transition-colors">돌봄일지</Link>
              <a href="https://biz.carebalance.co.kr" target="_blank" rel="noopener noreferrer" className="text-sm text-slate-400 hover:text-white transition-colors">시설관리자</a>
            </div>
          </div>

          {/* Guides */}
          <div>
            <h3 className="text-sm font-bold text-white mb-4">요양 가이드</h3>
            <div className="flex flex-col gap-2.5">
              <Link to="/blog" className="text-sm text-slate-400 hover:text-white transition-colors">블로그</Link>
              <Link to="/guide/care-grade" className="text-sm text-slate-400 hover:text-white transition-colors">요양등급이란?</Link>
              <Link to="/guide/facility-types" className="text-sm text-slate-400 hover:text-white transition-colors">시설 종류와 차이점</Link>
              <Link to="/guide/cost" className="text-sm text-slate-400 hover:text-white transition-colors">요양 비용 가이드</Link>
              <Link to="/guide/resources" className="text-sm text-slate-400 hover:text-white transition-colors">정부/공공기관 안내</Link>
            </div>
          </div>

          {/* Company & Legal */}
          <div>
            <h3 className="text-sm font-bold text-white mb-4">회사 및 정책</h3>
            <div className="flex flex-col gap-2.5">
              <Link to="/about" className="text-sm text-slate-400 hover:text-white transition-colors">회사소개</Link>
              <Link to="/contact" className="text-sm text-slate-400 hover:text-white transition-colors">문의하기</Link>
              <Link to="/terms/terms-of-service" className="text-sm text-slate-400 hover:text-white transition-colors">서비스 이용약관</Link>
              <Link to="/terms/privacy-policy" className="text-sm font-semibold text-slate-300 hover:text-white transition-colors">개인정보 처리방침</Link>
              <Link to="/terms/marketing-consent" className="text-sm text-slate-400 hover:text-white transition-colors">마케팅 정보 수신</Link>
            </div>
          </div>
        </div>

        {/* 사업자 정보 */}
        <div className="mt-10 pt-8 border-t border-slate-800">
          {/* 서비스명(한글 브랜드)을 본문에 노출 — 상호(법인명)는 그대로 둔다 (ssr-spec §17.1) */}
          <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-slate-500 leading-relaxed">
            <span>서비스명: 케어밸런스(CareBalance)</span>
            <span className="text-slate-700">|</span>
            <span>상호: 파인드플레이스</span>
            <span className="text-slate-700">|</span>
            <span>대표: 우상철</span>
            <span className="text-slate-700">|</span>
            <span>사업자등록번호: 587-18-02704</span>
            <span className="text-slate-700">|</span>
            <span>이메일: contact@carebalance.co.kr</span>
          </div>
          <div className="mt-1 text-xs text-slate-500">
            주소: 경기도 의정부시 서부로 545 경민대학교 창업관 7층 754-1호 파인드플레이스
          </div>
          <div className="mt-3 flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-slate-600">
            <span>국민건강보험공단 기본정보·평가등급 기반</span>
            <span className="text-slate-700">|</span>
            {/* 심평원은 요양병원 진료시간·병상 등 병원 정보만 제공 — 평가등급 출처가 아님 */}
            <span>건강보험심사평가원 요양병원 정보</span>
            <span className="text-slate-700">|</span>
            <span>보건복지부 정책 연계</span>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-6">
          <p className="text-xs text-slate-500">
            &copy; 2026 파인드플레이스. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}
